export default __webpack_public_path__ + "static/time-axis-with-irregular-intervals-9a922b841914fae138044dfb2c58f5c2.png";